<form [formGroup]="FormAlterarProduto">

    <div class="row justify-content-center">
        <div class="col-sm-12 col-12">
            <mat-form-field appearance="fill" style="width: 100%">
                <mat-label>Nova Categoria</mat-label>
                <input formControlName="CategoriaNova" matInput type="text" readonly>
                <button *ngIf="FormAlterarProduto.value.Categoria == null" mat-button mat-icon-button matSuffix aria-label="Clear" (click)="pesquisarCategorias()">
          <mat-icon>search</mat-icon>
        </button>
                <button *ngIf="FormAlterarProduto.value.Categoria != null" mat-button mat-icon-button matSuffix aria-label="Clear">
          <mat-icon>close</mat-icon>
        </button>
            </mat-form-field>
        </div>
    </div>

    <div class="row justify-content-end"><button mat-raised-button [mat-dialog-close]="closeDialog" style="width: 15%;" color="primary" (click)="alterarLote()">Gravar</button></div>
</form>
